import { motion } from "framer-motion";
import {
  ShieldCheck,
  Clock4,
  PackageCheck,
  Headphones,
  Zap,
} from "lucide-react";

const REASONS = [
  {
    num: "01",
    icon: ShieldCheck,
    title: "Affidabilità",
    desc: "Un partner solido per ogni spedizione, dal primo all'ultimo chilometro.",
  },
  {
    num: "02",
    icon: Clock4,
    title: "Puntualità nelle consegne",
    desc: "Rispettiamo i tempi concordati con precisione e disciplina operativa.",
  },
  {
    num: "03",
    icon: PackageCheck,
    title: "Cura della merce",
    desc: "Ogni carico è gestito con attenzione e mezzi adeguati alla tipologia.",
  },
  {
    num: "04",
    icon: Headphones,
    title: "Assistenza diretta",
    desc: "Parli sempre con noi: zero call center, comunicazione chiara e diretta.",
  },
  {
    num: "05",
    icon: Zap,
    title: "Preventivi rapidi",
    desc: "Risposta veloce via WhatsApp con tariffe trasparenti e dettagliate.",
  },
];

const WAREHOUSE_IMG =
  "https://images.pexels.com/photos/10410106/pexels-photo-10410106.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1400";

export default function WhyUs() {
  return (
    <section
      id="vantaggi"
      data-testid="whyus-section"
      className="relative py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 z-0">
        <img
          src={WAREHOUSE_IMG}
          alt="Magazzino logistico"
          className="h-full w-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#050505] via-black/85 to-[#050505]" />
        <div className="absolute top-1/2 -translate-y-1/2 -right-32 h-[400px] w-[400px] rounded-full bg-[#0055ff] opacity-[0.08] blur-[140px]" />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 md:px-12">
        <div className="max-w-3xl mb-16">
          <div className="flex items-center gap-3 mb-6">
            <span className="h-px w-12 bg-blue-400" />
            <span className="text-[11px] font-semibold uppercase tracking-[0.32em] text-blue-300">
              Perché scegliere Bennici
            </span>
          </div>
          <h2
            data-testid="whyus-title"
            className="font-heading text-4xl md:text-5xl lg:text-6xl font-black uppercase tracking-[-0.02em] leading-[1.02] text-white"
          >
            Cinque ragioni per{" "}
            <span className="metal-text-gradient">fidarsi</span> di noi.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-px bg-white/5">
          {REASONS.map((r, i) => (
            <motion.div
              key={r.title}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.2 }}
              transition={{ duration: 0.5, delay: 0.07 * i }}
              className="group relative bg-[#070A12] hover:bg-[#0A0E18] transition-colors p-8 md:p-10 min-h-[260px] flex flex-col"
              data-testid={`whyus-item-${i}`}
            >
              <div className="flex items-start justify-between mb-6">
                <r.icon
                  size={32}
                  className="text-blue-400 group-hover:text-[#00e5ff] transition-colors"
                  strokeWidth={1.8}
                />
                <span className="font-heading text-sm font-bold tracking-[0.2em] text-blue-300/70">
                  {r.num}
                </span>
              </div>
              <h3 className="font-heading text-2xl font-bold text-white uppercase tracking-tight leading-tight">
                {r.title}
              </h3>
              <p className="mt-3 text-sm text-gray-400 leading-relaxed">
                {r.desc}
              </p>

              {/* hover line */}
              <span className="absolute bottom-0 left-0 h-px w-0 bg-gradient-to-r from-[#0055ff] to-[#00e5ff] group-hover:w-full transition-all duration-700" />
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
